import { Types } from "../../actions/user/changePassword.actions";

const INITIAL_STATE = {
  success: false,
  loading: false,
  error: null
};

export default function changePassword(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.CHANGE_PASSWORD: {
      return {
        ...state,
        ...INITIAL_STATE,
        loading: true
      };
    }

    case Types.CHANGE_PASSWORD_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case Types.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true
      };
    }

    case Types.CHANGE_PASSWORD_RESET: {
      return {
        ...state,
        ...INITIAL_STATE
      };
    }

    default:
      return state;
  }
}
